import 'odometer/odometer';

document.addEventListener("turbolinks:load", function() {
  $(".odometer").each(function() {
    var value = $(this).data("value");
    this.innerHTML = 0;
    this.innerHTML = value;
  });
});
